import React from 'react';
import PropTypes from 'prop-types';
import './DashboardMidgetWidget.scss';

const DashboardMidgetWidget = ({ children }) => {
    return (
        <div className="col-12 col-md-6">
            {children}
        </div>
    );
};

DashboardMidgetWidget.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.element,
    ]),
};

export default DashboardMidgetWidget;
